module.exports = __webpack_public_path__ + "img/message.932e0051.png";